import { defineMessage } from '@formatjs/intl';
import { captureException as sentryCaptureException } from '@sentry/react';

import { captureException } from 'src/shared/utils/captureException';

export enum SeriesAccessType {
  EVERYONE = 'EVERYONE',
  MODERN_HEALTH_MEMBERS_ONLY = 'MODERN_HEALTH_MEMBERS_ONLY',
}

export function formatSeriesAccessType(
  seriesAccessType?: SeriesAccessType | string | null,
  seriesName?: string,
): {
  defaultMessage: string;
} {
  switch (seriesAccessType) {
    case SeriesAccessType.EVERYONE:
      return defineMessage({ defaultMessage: 'Open to public' });
    case SeriesAccessType.MODERN_HEALTH_MEMBERS_ONLY:
      return defineMessage({ defaultMessage: 'Members only' });
    default:
      sentryCaptureException(
        new Error(
          `Unhandled Series access type ${seriesAccessType} in ${seriesName}, defaulting to public.`,
        ),
      );
      captureException(new Error(`Unhandled Series access type, defaulting to public.`), {
        seriesAccessType,
        seriesName,
      });
      return defineMessage({ defaultMessage: 'Open to public' });
  }
}
